// extracted by mini-css-extract-plugin
module.exports = {"UserMenu":"UserMenu_UserMenu__1tKym","LogOut":"UserMenu_LogOut__3AESA"};